__turbopack_context__.v({
  "chevron": "ReturnLogEvents-module-scss-module__Lg2ifW__chevron",
  "event": "ReturnLogEvents-module-scss-module__Lg2ifW__event",
  "event-clickable": "ReturnLogEvents-module-scss-module__Lg2ifW__event-clickable",
  "event-container-hidden": "ReturnLogEvents-module-scss-module__Lg2ifW__event-container-hidden",
  "event-open": "ReturnLogEvents-module-scss-module__Lg2ifW__event-open",
  "show-more-button": "ReturnLogEvents-module-scss-module__Lg2ifW__show-more-button",
  "two-returns": "ReturnLogEvents-module-scss-module__Lg2ifW__two-returns",
});
